module.exports = __webpack_public_path__ + "img/BestOfQuarterDigitalIdentityDesign.cc9de93c.jpg";